<template>
  <div>
    <b-carousel
      class="mt-4"
      id="carousel"
      v-model="slide"
      controls
      fade
      :interval="0"

      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      @input="$emit('input', $event)"
    >
      <b-carousel-slide v-for="image in images" :key="image.id">
        <template v-slot:img>
          <img
            class="d-block m-auto img-fluid"
            :src="image"
            alt="image slot"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    images: Array,
    value: Number
  },
  components: {},

  data() {
    return {
      slide: 0,
      sliding: null,
      reference: null
    };
  },
  methods: {
    onSlideStart() {
      this.sliding = true;
    },
    onSlideEnd() {
      this.sliding = false;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.slide = value
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../variables.scss";

.carousel {
  background: $eeposDarkGray;
}
</style>